import React, { useState, useRef, useEffect } from "react";
import { MessageCircle, X, Send, CalendarCheck } from "lucide-react";
import { sr } from "../../lib/sr";
import "../../pages/smartreach/marketing.css";

const GREETING = "Hi, I'm Susan 👋 I help local businesses turn foot traffic into real customers. What kind of business are you running?";

export default function AskSusan() {
  const [open, setOpen] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([{ role: "susan", text: GREETING }]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [booked, setBooked] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, open, busy]);

  const send = async (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    setMessages((m) => [...m, { role: "user", text }]);
    setBusy(true);
    try {
      const data = await sr.susanChat(text, sessionId);
      setSessionId(data.session_id);
      setMessages((m) => [...m, { role: "susan", text: data.reply }]);
      if (data.appointment) setBooked(true);
    } catch {
      setMessages((m) => [...m, { role: "susan", text: "Sorry — I hit a snag. Mind trying that again in a moment?" }]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {!open && (
        <button type="button" className="susan-fab" onClick={() => setOpen(true)}
          data-testid="ask-susan-fab" aria-label="Chat with Susan">
          <MessageCircle size={20} />
          <span>Ask Susan</span>
        </button>
      )}

      {open && (
        <div className="susan-panel" data-testid="ask-susan-panel" role="dialog" aria-label="Ask Susan">
          <div className="susan-head">
            <div className="susan-head-id">
              <span className="susan-avatar">S</span>
              <div>
                <strong>Ask Susan</strong>
                <span className="susan-status">SmartReachAI · usually replies instantly</span>
              </div>
            </div>
            <button type="button" onClick={() => setOpen(false)} data-testid="ask-susan-close" aria-label="Close chat">
              <X size={18} />
            </button>
          </div>

          <div className="susan-body" ref={scrollRef} data-testid="ask-susan-messages">
            {messages.map((m, i) => (
              <div key={i} className={`susan-msg ${m.role}`}>{m.text}</div>
            ))}
            {busy && (
              <div className="susan-msg susan typing"><span /><span /><span /></div>
            )}
            {booked && (
              <div className="susan-booked" data-testid="ask-susan-booked">
                <CalendarCheck size={15} /> Thanks! Your request is in — our team will confirm your appointment shortly.
              </div>
            )}
          </div>

          <form className="susan-input" onSubmit={send}>
            <input value={input} onChange={(e) => setInput(e.target.value)}
              placeholder="Type your message…" data-testid="ask-susan-input" autoFocus disabled={busy} />
            <button type="submit" data-testid="ask-susan-send" aria-label="Send" disabled={busy || !input.trim()}>
              <Send size={17} />
            </button>
          </form>
        </div>
      )}
    </>
  );
}
